const themeAccordionComponent = {
  variants: {
    leftNav: {
      root: {
        fontSize: 'sm'
      },
      container: {
        borderWidth: 0
      },
      button: {
        textAlign: 'left',
        fontSize: 'sm'
        // textDecoration: 'none',
      },
      panel: {
        paddingTop: 0,
        paddingRight: 0,
        fontSize: 'sm'
      }
    }
  }
};

export default themeAccordionComponent;
